import React from "react";

class SpeakerTimer extends React.Component {
  state = {
    time: "",
  };
  componentDidMount() {
    this.props.hubConnection.on("onGetCurrentTime", (res) => {
      var t = new Date(res);
      this.timer = setInterval(() => this.countDown(t.setSeconds(t.getSeconds() + 1)), 1000);
    });
    this.getTime();
  }
  getTime = () => {
    if (this.props.hubConnection) {
      this.props.hubConnection.invoke("getCurrentTime").catch((err) => {
        console.error(err);
      });
    }
  };
  countDown = (currentTime) => {
    const { timeout, callback, buttonTimer } = this.props;

    let secondsLeft = (new Date(timeout) - new Date(currentTime)) / 1000;
    let time = "";
    if (buttonTimer) {
      time = (secondsLeft % 60).toFixed(0).toString();
    } else if (secondsLeft > 60) {
      let minutes = Math.floor(secondsLeft / 60).toString();
      let seconds = (secondsLeft % 60).toFixed(0).toString();

      if (minutes.length == 1) minutes = "0" + minutes;
      if (seconds < 10) seconds = "0" + seconds;

      time = `${minutes}:${seconds}`;
    }
 
    else if (secondsLeft <= 9 && secondsLeft >= 0) {
      time = `00:0${(secondsLeft % 60).toFixed(0)}`;
    } else if (secondsLeft < 0 && secondsLeft > -10) {
      time = `-00:0${(Math.abs(secondsLeft) % 60).toFixed(0)}`;
    } else if (secondsLeft < -10 && secondsLeft > -60) {
      time = `-00:${(Math.abs(secondsLeft) % 60).toFixed(0)}`;
    } else if (secondsLeft < -60) {
      let minutes = Math.floor(Math.abs(secondsLeft) / 60).toString();
      let seconds = (Math.abs(secondsLeft) % 60).toFixed(0).toString();

      if (minutes.length == 1) minutes = "0" + minutes;
      if (seconds < 10) seconds = "0" + seconds;

      time = `-${minutes}:${seconds}`;
    } else {
      time = `00:${(secondsLeft % 60).toFixed(0)}`;
    }
    this.setState({ time });
  };
  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  render() {
    const { buttonTimer, template, preWarning, color = "#000" } = this.props;
    let style = {};
    if (template !== undefined) style = template;
    if (buttonTimer) {
      return null;
    }
    return (
      <div style={{ textAlign: "center", width: "100%" }}>
        <h3 className="primary-text" style={preWarning ? style.title : style.label}>
          {this.state.time}
        </h3>
      </div>
    );
  }
}

export default SpeakerTimer;
